import React, { Component } from 'react';
import logo from '../imgs/et2logo.png';
import FlagPng from '../imgs/Flag.png';
import {Button,Icon, Input} from 'antd';
import {Pagination} from 'react-bootstrap';
import SubmitModal from '../component/SubmitModal';
import Time from "../component/Time";
import QuestionItem from './QuestionItem';
import {historyPush, request, secToTime,requestAdminFormData} from '../utils/Util';
import Info from "./Info";
import Draggable from 'react-draggable';
import {connect} from 'react-redux';
import {Route} from "react-router-dom";
import Select from 'react-select';
import {bindActionCreators,createStore} from 'redux';
import * as actions from '../actions/evaluation';
import myEmitter from "../component/my-events";

import './Question.css';
import {Match} from "../component/Match";
import {Science} from "../component/Science";
import {English} from "../component/English";
import {Reading} from "../component/Reading";
localStorage.clear();

const ButtonGroup = Button.Group;
// const Option = Select.Option;

class Question extends Component {
    constructor(props) {
        super(props);
        // 初始状态
        this.state = {
            current: 1,
            count:50,
            time: 1800,
            timeObj:{},
            flag:{},
            timeText: '30:00',
            ToolsValue:'',
            DraggableFlag: false,
            selectedOption: null,
            showFlag: false
        };
    }

    async handelSubmitOk(){
        myEmitter.emit('nextQuestion');


        const {answer,evaluation,match} = this.props;

        console.log();

        var json = {};
        var c = {};
        var b = evaluation.datas.content_object_content.units;
        b.map((item,index)=>{

            c[item.questions.uuid] = (answer[index] && answer[index].value != '' ) ?  {'id':item.questions.id,'answer': answer[index].value } : {'id': item.questions.id};
            return c;
        })
        this.setState({
            token: 'Uyy1wyGNqTNipwnGNPdrtLhNRpC5MJY6QJ9L4RinHPc',
            questions: JSON.stringify(c)
        },()=>{
            console.log(this.state);
            console.log(this.refs);
            // this.refs.formSubmit.click();
            this.refs.formSubmit.submit();
        })


    }


    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
        console.log(`Option selected:`, selectedOption);
        selectedOption.map((item,index)=>{
            if(item.value === 'Magnifier' && !this.state.DraggableFlag){
                var mm = document.getElementById('root').innerHTML;
                this.setState({DraggableFlag : true,ToolsValue:selectedOption},()=>{
                    this.innerHtmlDom(mm);
                })
            }
        })
        if(selectedOption.length === 0){
            this.setState({DraggableFlag: false})
            }

    }

    handelPageItemClick(i){
        const {actions,currentEvaluation,answerActions} = this.props;
        var newPage = {page:i};
        actions.setCurrentEvaluation(newPage);
        myEmitter.emit('nextQuestion');
    }

    handelNextClick(){
        const {actions,currentEvaluation,answerActions,evaluation} = this.props;
        if(evaluation.datas.content_object_content && currentEvaluation.page <  evaluation.datas.content_object_content.units.length-1){
            var newPage = {page:currentEvaluation.page+1};
            // actions.setAnswer([])
            console.log(newPage);
            actions.setCurrentEvaluation(newPage);
        }
        myEmitter.emit('nextQuestion');
    }

    handelPrevClick(){
        const {actions,currentEvaluation} = this.props;

        if(currentEvaluation.page >  -2){
            var newPage = {page:currentEvaluation.page-1};
            console.log(newPage);
            actions.setCurrentEvaluation(newPage);
            myEmitter.emit('prevQuestion');
        }


    }

    async _setAnswer(index,value){
        const {match,answercurrentEvaluation,answer} = this.props;
        var params = {
            url: `${match.params.eurl}_${match.params.type}`,
            info: {...answer.answers,index:value}
        }
        const answerSet = await request(`/questionnaires/test_questions_save/`,'POST', params);
        console.log(params,answerSet);
    }



    startTime = ()=>{
        var time = this.state.time-1;
        // this.setState({time:time})
        this.state.time = time;
        this.state.timeText = secToTime(this.state.time);
        this.setState({});
    }

    handelSubmit(){

        myEmitter.emit('nextQuestion');
        this.refs.submitModal.showModal();
    }

    intervalTime(){
        if(this.state.time > -1){
            setInterval(this.startTime,1000)
        }else{
            clearInterval()
        }
    }


    innerHtmlDom = (h)=>{
        var domW  = document.getElementsByClassName('App')[0].clientWidth+''
        var domH  = document.getElementsByClassName('App')[0].clientHeight+''
        console.log(h);
        this.refs.Magnifier_box.innerHTML = h;
        console.log(this.refs.Magnifier_box);
        document.getElementsByClassName('App')[1].style.width = `${domW}px`
        document.getElementsByClassName('App')[1].style.height = `${domH}px`
    }



    handleDrag = (e,data)=>{
        console.log(e)
        console.log(data,'data')
        var falg = document.getElementById('root').clientWidth;
        var DragWidth = document.getElementsByClassName('Magnifier_box')[0].clientWidth;
        var DragHeight = document.getElementsByClassName('Magnifier_box')[0].clientHeight;
        document.getElementsByClassName('App')[1].style.left = `-${data.x*2}px`;
        document.getElementsByClassName('App')[1].style.top = `-${data.y*2}px`;

        // document.getElementsByClassName('App')[1].style.height = `${domH}px`
    }

    handelPrevPageClick(){

    }

    async getAnswer(){
        const {evaluationActions,actions,clearAnswers,answerActions,match,evaluation} = this.props;
        var p = {url:`${match.params.eid}_${match.params.eurl}_take_${match.params.type}`}
        const K = await request(`/questionnaires/test_questions_save/`,'GET',p);
        console.log(K,'获取答案');
        if(K.detail.results[0]){
            var a = JSON.parse(K.detail.results[0].info);
            Object.keys(a).map((item)=>{
                actions.setAnswer(parseInt(item),a[`${item}`],a[`${item}`]);
            })
            console.log(parseInt(Object.keys(a)[Object.keys(a).length-1]),'获取的页')
            var currnt = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.numberOfQuestions : null;
            if( currnt && parseInt(Object.keys(a)[Object.keys(a).length-1]) > currnt) {
                actions.setCurrentEvaluation({page: -2 });
                actions.clearAnswer('clear');
            }else{
                actions.setCurrentEvaluation({page: parseInt(Object.keys(a)[Object.keys(a).length-1])});
            }
        }else{
            actions.setCurrentEvaluation({page: -2});
            actions.clearAnswer('clear');
        }

    }

    async getData(){
        const {actions,match} = this.props;
        // console.log('1111-----------------------')
        // const K = await requestAdminFormData(`http://t.loviact.org/test/${match.params.eid}/${match.params.eurl}/take/${match.params.eid}`,'POST',{});
        // console.log(K,'创建')

        var params = {entity_id: match.params.type};
        const questions = await request(`/questionnaires/node__content_object/`,'get',params);
        // console.log(JSON.parse(questions.detail.results[0].content_object_content));
        this.setState({questions:questions.detail.results, showFlag:true});
        // evaluationActions.setCurrentEvaluation(questions.data)
        actions.setEvaluation(questions.detail);
        this.getAnswer(questions.detail);
    }


    onChange = (page) => {
        console.log(page);
        this.setState({
            current: page,
        });
    }

    componentDidMount() {

        const {evaluation} = this.props;
        this.getData();


        document.addEventListener('keydown', function(e){
            if(e.ctrlKey && e.key === 'f'){
                return false;
            }
        })


        // this.intervalTime();
    }


    flagClick(){
        const {currentEvaluation} = this.props;
        const {flag} = this.state;
        if(flag[currentEvaluation.page]){
            delete flag[currentEvaluation.page];
        }else{
            flag[currentEvaluation.page] = true;
        }

        console.log(flag);
        this.setState({flag})
    }

    // handleChange = (selectedOption) => {
    //     this.setState({ selectedOption });
    //     console.log(`Selected: ${selectedOption.label}`);
    // }

    render() {
        const {evaluation,currentEvaluation,match,answer} = this.props;
        const options = [
            { value: 'Magnifier', label: 'Magnifier' },
            { value: 'strawberry', label: 'Strawberry' },
            { value: 'vanilla', label: 'Vanilla' }
        ];

        const {DraggableFlag, showFlag} = this.state;
        var pageDom = [];

        const { selectedOption , flag} = this.state;
        const value = selectedOption && selectedOption.value;
        var PaginationItem=[];
        if(evaluation.datas.content_object_index) {
            for (var i = 0; i < evaluation.datas.content_object_index.numberOfQuestions; i++) {
                if(flag[i]){
                    PaginationItem.push(< Pagination.Item className={ answer[i] && answer[i].value ? 'complete' : ''} key={i}
                                                          active={i === currentEvaluation.page}
                                                          onClick={this.handelPageItemClick.bind(this, i)}> {i + 1}
                                                          <div className={flag[i] ? 'flag_icon' : 'flag_icon_hidden'}>
                                                              {/*<Icon type="flag" />*/}
                                                              <img src={FlagPng} alt=""/>
                                                          </div></ Pagination.Item>)
                }else{
                    PaginationItem.push(< Pagination.Item className={ answer[i] && answer[i].value ? 'complete' : ''} key={i}
                                                          active={i === currentEvaluation.page}
                                                          onClick={this.handelPageItemClick.bind(this, i)}> {i + 1} </ Pagination.Item>)
                }

            }
        }
        return (
            <div className='question'>
                <header>
                    <div className='header_lf'>
                        <img src={logo} alt=""/>
                        <Button className='Prev' onClick={this.handelPrevClick.bind(this)}>Prev</Button>
                        <Button>Nav</Button>
                        <Button onClick={this.handelNextClick.bind(this)}>Next</Button>
                    </div>
                    <div className='header_rt'>
                        {/*<Select defaultValue="Tools" style={{ width: 100 }} onChange={this.handleChange.bind(this)}>*/}
                            {/*<Option value="Magnifier">Magnifier</Option>*/}
                            {/*<Option value="lucy">Lucy</Option>*/}
                            {/*<Option value="Yiminghe">yiminghe</Option>*/}
                        {/*</Select>*/}
                        <Select className='selectedOption'
                            value={selectedOption}
                            isMulti={true}
                            onChange={this.handleChange}
                            options={options}
                        />

                        <span className='icon-box'>
                            <ButtonGroup>
                              <Button><Icon type="zoom-out" /></Button>
                              <Button><Icon type="redo" /></Button>
                              <Button><Icon type="zoom-in" /></Button>
                            </ButtonGroup>
                        </span>
                        <Button>Clear Highlight</Button>
                        <Button onClick={this.handelSubmit.bind(this)}>End Section</Button>
                        <Time setRef={(r) => this.time_box = r} match={match} timeData={this.state.timeObj} />
                    </div>
                </header>
                <section>

                    <QuestionItem ref='questionItem' setAnswerFn={this._setAnswer.bind(this)} match={match} />
                    {
                        DraggableFlag &&
                        <Draggable
                            onDrag={this.handleDrag}>
                            <div  ref='Magnifier_box' className='Magnifier_box'>

                            </div>
                        </Draggable>
                    }

                    <form style={{display:"none"}} ref='formSubmit' method="post" action={`/test/${match.params.eid}/${match.params.eurl}/submit/${match.params.type}`}>
                        <input hidden={true} type="text" name='token' value={sessionStorage.getItem('TT')}/>
                        <input hidden={true} type="text" name='questions' value={this.state.questions}/>
                        <Input className='btn btn-xs btn-primary' type="submit" ref="formSubmit" name="" value=''/>
                    </form>
                </section>
                <aside>
                    {/*<Pagination pageSizeOptions={[1,10,100,200]} current={this.state.current} onChange={this.onChange} total={500} />*/}
                    < Pagination >
                        < Pagination.First className="page_lf"  />
                        < Pagination.Item className={currentEvaluation.page > -2 ? 'page_info complete' : 'page_info'}  key={-2} active={-2 === currentEvaluation.page} > Info  </ Pagination.Item >
                        < Pagination.Item className={currentEvaluation.page > -1 ? 'page_instr complete' : 'page_instr'} key={-1} active={-1 === currentEvaluation.page} > Instr </ Pagination.Item >
                        {PaginationItem}
                        < Pagination.Last className="page_lf" onClick={this.handelPrevPageClick.bind(this)}  />
                    </ Pagination >

                    <div className='flag_box'>
                        <div onClick={this.flagClick.bind(this)} className='flag_button'>
                            {/*<Icon type="flag" theme="filled" />*/}
                            {showFlag?<img src={FlagPng} alt=""/>:""}
                                Flag
                        </div>
                    </div>
                </aside>
                <SubmitModal ref='submitModal' submit={this.handelSubmitOk.bind(this)} />
            </div>
        );
    }
}


Question = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer.answers
}), (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
}))(Question);
export default Question;
